import React,{useEffect,useState} from "react";
import "./sections.scss";
import {BlogList_api} from "../../Blog/BlogServices";
import {useHistory} from "react-router-dom";

function BlogSec({item}){

    const history = useHistory()

    useEffect(()=>{
        getBlogs()
    },[])

    const [blogs,set_blogs] = useState([])

    const getBlogs = async()=>{
        try{
            const res = await BlogList_api()
            set_blogs(res.data)
        }catch(e){
            console.error(e)
        }
    }

    const limitText = (t)=>{
        return t.substr(0, 40)
    }


    return(
        <div className="blog-sec">
            <div className="blog-list">
                {blogs.map(b=>{
                    return(
                        <div className="blog-item" onClick={()=>history.push(`/service-detail/${b.uid}`,{event:b})}>
                            <div className="blog-item-img">
                                <img src={b.cover} alt=""/>
                            </div>
                            <div className="blog-item-info">
                                <div className="blog-item-title">
                                    {b.title}
                                </div>
                                <div className="blog-item-desc">
                                    {limitText("بلفاروپلاستی یا جراحی پلاستیک پلک به عمل زیبایی گفته می شود که در آن پوست یا چربی اضافه پلک که باعث افتادگی و بد فرم شدن پلک شده را حذف می کنند.\\r\\n\\r\\nبلفاروپلاستی نوعی جراحی ساده سرپایی بدون نیاز به بیهوشی است که پلک های افتاده را ترمیم می نماید. این ترمیم شامل برداشتن پوست چربی و عضله اضافه است. زمانی که پا به سن می گذارید. یا به دلیل استفاده مکرر از لب تاپ – موبایل –تلوزیون – پلک شما کش آمده و عضلات نگه دارنده را تضعیف می نماید.\\r\\n\\r\\nنتیجه این امر انباشت چربی اضافه در پایین و بالای پلک شماست. و در ادامه منجر به آویزان شدن ابروها پلک بالایی و پف زیر چشم می گردد. آویزان شدن پوست اطراف چشم ها علاوه بر مسن تر نشان دادن شما و ربودن زیبایی ظاهریتان کاهش دید جانبی را نیز به همراه دارد")}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default BlogSec
